<div #destination class="searchInputDestination__cont">
  <div class="searchInputDestination__input" [class.results]="isResultsPage">
    <app-ds-input-text
      [isReadonly]="true"
      [isDisabled]="isDisabled"
      [icon]="icon"
      [size]="inputSize"
      [filled]="filled"
      [staticFilled]="staticFilled"
      [label]="'SEARCH_MODULE.LOCATION_SEARCH.TO' | transloco"
      [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.TO' | transloco"
      [value]="place?.InputType ? (
        place.InputType === hotelDestinationInputType.hotel ? 
          place?.hotel_name : place?.NameFull
        ) : ''
      "
      [isFailed]="showError"
      [failedMessage]="'SEARCH_MODULE.DESTINATION_INPUT' | transloco"
      (clickEvent)="toggleInput()">
    </app-ds-input-text>
  </div>
  <div class="searchInputDestination__autocomplete">
    <app-search-input-autocomplete
      [searchType]="searchType"
      [placeType]="placeType"
      [query]="query"
      [title]="'SEARCH_MODULE.DESTINATION_INPUT_HEADER' | transloco"
      [isMobile]="isMobile"
      [viewAutocomplete]="showInput"
      [inputPlaceListIcon]="icon"
      [inputPlaceListLabel]="'SEARCH_MODULE.LOCATION_SEARCH.TO' | transloco"
      [inputPlaceListPlaceholder]="'SEARCH_MODULE.DESTINATION_INPUT' | transloco"
      [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
      [hotelAndLocationsAutocomplete]="autoCompletePlaces"
      (closeAutocomplete)="toggleInput()"
      (setQuery)="setQuery($event)"
      (selectPopularPlace)="emitSelectSimplePlace($event)"
      (selectHotelEvent)="emitSelectHotel($event)"
      (selectLocationEvent)="emitSelectHotelLocation($event)"
      (popularSelected)="popularAmplitudeEvent.emit($event)">
    </app-search-input-autocomplete>
  </div>
</div>
